import type { FC } from 'react';
interface Props {
  message: { content?: string; message_text?: string; user_name?: string; user?: { name: string }; metadata?: { actor?: string; characterName?: string } };
  isOwnMessage: boolean;
  time: string;
}
const StudentChatMessage: FC<Props> = ({ message, isOwnMessage, time }) => {
  const isAiStudent = message.metadata?.actor === 'ai_student';
  const name = isAiStudent ? message.metadata?.characterName || 'Alex'
    : message.user_name || message.user?.name || 'Unknown User';
  return (
    <div className={`flex ${isOwnMessage ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-xs lg:max-w-md ${isOwnMessage ? 'order-2' : 'order-1'}`}>
        {!isOwnMessage && <div className="text-xs text-gray-500 dark:text-gray-400 mb-1 ml-2">{name}</div>}
        <div className={`px-4 py-2 rounded-2xl ${isOwnMessage ? 'bg-blue-600 text-white rounded-br-md'
          : isAiStudent ? 'bg-purple-100 dark:bg-purple-900/20 text-purple-900 dark:text-purple-100 border border-purple-200 dark:border-purple-800 rounded-bl-md'
          : 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 rounded-bl-md'}`}>
          <p className="text-sm">{message.content || message.message_text}</p>
        </div>
        <div className={`text-xs text-gray-500 dark:text-gray-400 mt-1 ${isOwnMessage ? 'text-right mr-2' : 'ml-2'}`}>{time}</div>
      </div>
    </div>
  );
};
export default StudentChatMessage;
